import { supabase } from "@/integrations/supabase/client";

export interface QueryEnhancement {
  originalQuery: string;
  enhancedCriteria: any;
  confidence: number;
  reason: string;
}

export const enhanceQuery = async (query: string): Promise<QueryEnhancement | null> => {
  try {
    console.log('🧠 === QUERY ENHANCEMENT SERVICE ===');
    console.log('Original query:', query);
    
    // Call the enhancement edge function
    const { data, error } = await supabase.functions.invoke('enhance-search-query', {
      body: { query }
    });

    if (error) {
      console.error('Query enhancement error:', error);
      return null;
    }

    console.log('Enhancement result:', data);
    
    // Extract useful enhancements
    if (data.enhancedCriteria || data.seasonalAdjustments?.length > 0) {
      return {
        originalQuery: query,
        enhancedCriteria: data.enhancedCriteria,
        confidence: data.suggestions.hasEnhancements ? 0.8 : 0.5,
        reason: data.enhancementReason || 'Seasonal and pattern-based improvements'
      };
    }

    return null;
  } catch (error) {
    console.error('Query enhancement service error:', error);
    return null;
  }
};

export const analyzeQueryIntent = (query: string) => {
  const lowerQuery = query.toLowerCase();
  
  // Detect query patterns
  const patterns = {
    hasLocation: /\b(spanje|italië|griekenland|turkije|frankrijk|portugal|kroatië|cyprus|thailand|vietnam|egypte)\b/.test(lowerQuery),
    hasExperience: /\b(rondreis|stedentrip|safari|cruise|wintersport|wellness|cultureel|natuur|avontuur)\b/.test(lowerQuery),
    hasBudget: /\b(€\d+|max|maximaal|budget|goedkoop|luxe|premium)\b/.test(lowerQuery),
    hasFacilities: /\b(zwembad|all inclusive|strand|spa|wellness|adults only)\b/.test(lowerQuery),
    hasTimeframe: /\b(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december|zomer|winter|lente|herfst)\b/.test(lowerQuery),
    hasGroupSize: /\b(kinderen|familie|single|adults only|stelletje|groep)\b/.test(lowerQuery)
  };

  return {
    complexity: Object.values(patterns).filter(Boolean).length,
    patterns,
    queryType: getQueryType(patterns),
    suggestions: getQuerySuggestions(patterns, lowerQuery)
  };
};

const getQueryType = (patterns: any) => {
  if (patterns.hasLocation && patterns.hasExperience) return 'location_experience';
  if (patterns.hasLocation && patterns.hasFacilities) return 'location_facilities';
  if (patterns.hasLocation) return 'location_only';
  if (patterns.hasExperience) return 'experience_only';
  if (patterns.hasBudget) return 'budget_focused';
  return 'general';
};

const getQuerySuggestions = (patterns: any, query: string) => {
  const suggestions = [];
  
  if (!patterns.hasLocation) {
    suggestions.push('Voeg een bestemming toe voor betere resultaten (bijv. "Spanje", "Griekenland")');
  }
  
  if (!patterns.hasTimeframe && (patterns.hasLocation || patterns.hasExperience)) {
    suggestions.push('Geef een reistijd aan voor seizoensgebonden aanbevelingen');
  }
  
  if (!patterns.hasBudget && patterns.hasLocation) {
    suggestions.push('Voeg een budget toe om resultaten te filteren');
  }
  
  return suggestions;
};